document.addEventListener("DOMContentLoaded", function () {
  // -- begin customizations 2025-10-01
  const formElementsToHide =
    "#application_address1, #application_address2, #application_city, #application_zip, #SavedAddresses, #application_phone"
  const formElementsToAddRequirement = "#application_organization, #application_organization_role"
  const applicationApplicantNotes = document.querySelectorAll("#application_applicant_notes")
  const applicationApplicantNotesParent = document.querySelector(
    "#application_applicant_notes"
  ).parentElement
  const applicationOrganizationRole = document.querySelector(
    "#application_organization_role"
  ).parentElement
  const applicationAutoApprovedCode = document.querySelector("#application_auto_approved_code")
  const buttons = document.querySelectorAll(".form-actions button")
  const buttonReset = document.querySelector('.form-actions button[type="reset"]')

  // Remove require and hide inputs
  document.querySelectorAll(formElementsToHide).forEach(input => {
    input.removeAttribute("required")
    input.closest("[data-ap-field]").style.display = "none"
  })

  // Remove required on application_applicant_notes
  applicationApplicantNotes.forEach(input => {
    input.removeAttribute("required")
  })

  // Add required to inputs
  document.querySelectorAll(formElementsToAddRequirement).forEach(input => {
    input.setAttribute("required", "")
  })

  // add headings
  document
    .querySelector(".alliance-pro-wrapper .addresses")
    .insertAdjacentHTML("afterbegin", "<h4>Membership details</h4>")

  document
    .querySelector(".policy-field-wrapper")
    .insertAdjacentHTML(
      "beforebegin",
      '<div class="ap-option-box"><h4>Membership Policy</h4></div>'
    )

  // move applicant code after role
  applicationOrganizationRole.after(applicationAutoApprovedCode.parentElement)

  // update code placeholder
  applicationAutoApprovedCode.nextElementSibling.textContent = "XXX-XXXXXXX-XXXXXXXX"

  // add application code text
  applicationAutoApprovedCode.parentElement.insertAdjacentHTML(
    "beforebegin",
    '\
    <div class="ap-option-box">\
      <h4>Membership verification</h4>\
      <p>To activate your membership, <b>choose one of the three verification methods below:</b></p>\
      <div class="options" id="option1">\
        <p><b>Option 1: Pre-Approved Company</b></p>\
        <p>\
          If your employer is on our pre-approved list, you\'re already set. Just \
          make sure your Nidecker account is registered with your company email (e.g. @company.com). \
          No code or documents are required, you can move straight to the next step.\
        </p>\
      </div>\
      <div class="options" id="option2">\
        <p><b>Option 2: PRO / Activation Code</b></p>\
        <p>\
          If you\'ve received a PRO or Activation Code, enter it here to verify \
          your membership. No documents are needed, just enter your code \
          and continue to the next step.<br>\
            Format: XXX-XXXXXXX-XXXXXXXX\
        </p>\
      </div>\
    </div>\
  '
  )

  applicationApplicantNotesParent.insertAdjacentHTML(
    "beforebegin",
    '\
    <br>\
    <div class="ap-option-box">\
      <div class="options" id="option3">\
        <p><b>Option 3: Verify With a Document</b></p>\
        <p>\
          No code? No problem. Upload a document that confirms your \
          eligibility and add context in the comment section. \
          Eligible documents include proof of employment, service, or \
          membership. Examples are a work ID, pay stub, certificate, or \
          membership card.\
        </p>\
      </div>\
    </div>\
  '
  )

  // hide the prev explainer content for notes
  applicationApplicantNotesParent.nextElementSibling.style.display = "none"

  buttons.forEach(button => {
    button.classList.add("btn", "btn-primary", "btn-medium")
  })

  document.querySelector("#option2").appendChild(applicationAutoApprovedCode.parentElement)

  document.querySelector("#option3").appendChild(applicationApplicantNotesParent)
  document
    .querySelector("#option3")
    .appendChild(document.querySelector("file-upload").parentElement)

  // Add class to file button
  const fileUpload = document.querySelector("file-upload label span")
  fileUpload.classList.add("btn", "btn-small", "btn-secondary")

  // Add and remove class to reset button
  buttonReset.classList.add("btn-secondary")
  buttonReset.classList.remove("btn-primary")
  // -- end customizations 2025-10-01
})
